module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExObjArray,
      "code": _vm.ExObjArrayCode,
      "title": "Object array"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExHeader,
      "code": _vm.ExHeaderCode,
      "title": "Header"
    }
  }, [_c('p', [_vm._v("You can add your custom header to the autocomplete.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFooter,
      "code": _vm.ExFooterCode,
      "title": "Footer"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])]), _vm._v(" "), _c('p', [_vm._v("You can add your custom footer to the autocomplete.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomAsync,
      "code": _vm.ExCustomAsyncCode,
      "title": "Async with custom template"
    }
  }, [_c('p', [_vm._v("You can have a custom template by adding a scoped slot to it.")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("API from "), _c('a', {
    attrs: {
      "href": "https://www.themoviedb.org",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")])]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExInfiniteScroll,
      "code": _vm.ExInfiniteScrollCode,
      "title": "Async with infinite scroll"
    }
  }, [_c('p', [_vm._v("With "), _c('code', [_vm._v("check-infinite-scroll")]), _vm._v(" and "), _c('code', [_vm._v("infinite-scroll")]), _vm._v(" event you can listen to the end of the scroll list to implement an infinite scroll strategy.")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("API from "), _c('a', {
    attrs: {
      "href": "https://www.themoviedb.org",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")])]), _vm._v(".")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5901736d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/autocomplete/Autocomplete.vue
// module id = 1317
// module chunks = 6